import { useEffect } from 'react';
import axios from 'axios';
import { STORAGE_BASE } from '../config';
import { registerCustomFonts } from './widgetStyle';

const fmtOf = path => {
  const ext = String(path || '').split('.').pop().toLowerCase();
  if (ext === 'woff2') return 'woff2';
  if (ext === 'woff') return 'woff';
  if (ext === 'otf') return 'opentype';
  return 'truetype';
};

/** Apply the site-wide default typeface (admin → تم → فونت پیش‌فرض سایت).
 * Widgets that explicitly pick their own font keep it (inline style wins). */
export function applySiteFont(family) {
  const fam = (family && String(family).trim()) || 'IRANSans';
  const stack = `'${fam.replace(/'/g, '')}', sans-serif`;
  try {
    document.documentElement.style.setProperty('--site-font', stack);
    if (document.body) document.body.style.fontFamily = stack;
  } catch {}
}

/** Loads custom site fonts: injects @font-face rules + registers them in widget pickers. */
export function loadSiteFonts() {
  const fontsP = axios.get('/fonts').then(r => {
    const fonts = r.data?.fonts || [];
    if (!fonts.length) return;
    const css = fonts.map(f => {
      const files = f.files || {};
      return Object.entries(files).map(([weight, path]) => {
        const url = /^https?:\/\//.test(path) ? path : `${STORAGE_BASE}/${String(path).replace(/^\/+/, '')}`;
        return `@font-face{font-family:'${f.family}';src:url('${url}') format('${fmtOf(path)}');font-weight:${weight};font-style:normal;font-display:swap;}`;
      }).join('\n');
    }).join('\n');
    let el = document.getElementById('site-custom-fonts');
    if (!el) {
      el = document.createElement('style');
      el.id = 'site-custom-fonts';
      document.head.appendChild(el);
    }
    el.textContent = css;
    registerCustomFonts(fonts.map(f => ({ value: f.family, label: `${f.family} (سفارشی)` })));
  }).catch(() => {});
  const themeP = axios.get('/site-settings').then(r => {
    const t = r.data?.theme || {};
    applySiteFont(t.font || t.light?.font || 'IRANSans');
  }).catch(() => {});
  return Promise.allSettled([fontsP, themeP]);
}

export default function FontLoader() {
  useEffect(() => {
    loadSiteFonts();
    const on = () => loadSiteFonts();
    window.addEventListener('site-fonts-changed', on);
    window.addEventListener('site-theme-changed', on);
    return () => {
      window.removeEventListener('site-fonts-changed', on);
      window.removeEventListener('site-theme-changed', on);
    };
  }, []);
  return null;
}
